import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";

const Componetizacion: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <h1>
        <a href='https://docs.google.com/document/d/1HptnBZWk8ZS4mT50u9NiYahKZh85SrNGGk1owZGQQAM/edit'>
          Componetizacion
        </a>
      </h1>
      <p className='text-justify'>
        Uno de los pilares de la informatica es la abstracción, poder separar
        los problemas en diferentes capas es muy importante para poder atacar
        problemas grandes y complejos.
      </p>
      <p className='text-justify'>
        Siguiendo esa lógica, cuando hacemos un proyecto hay que entender que la
        complejidad de un mismo programa sube exponencialmente a medida que
        agregamos cosas, por eso tener un programa entero en un solo archivo es
        completamente inviable.
      </p>
      <p className='text-justify'>
        Debido a esto saber componetizar apropiadamente nuestra aplicación nos
        va a permitir mantener la complejidad de nuestro código bajo control,
        pudiendo atacar problemas aislados uno a la vez, en vez de tener que
        trabajar sobre todo el proyecto.
      </p>
      <h2>Lógica {`<->`} Interfáz</h2>
      <p className='text-justify'>
        La primera separación que tenes que respetar en tu proyecto es la de no
        mezclar código lógico con código de interfaz. ¿Qué quiere decir esto?
        Quiere decir que en una parte de tu proyecto tenes que definir tu
        interfaz, y en otra parte tenes que definir tu lógica. Eventualmente tu
        Interfáz le pedirá cosas a la lógica, pero la implementación de cada una
        debe estar en lugares distintos.
      </p>
      <p>Tomemos un ejemplo:</p>
      <pre>
        <code className='language-javascript rounded'>
          {`import React from "react";

const App: React.FC = () => {
	const [name, setName] = useState();
	
	useEffect(() => {
		fetch("https://whatIsMyName.com/getName")
		.then(name => {
			setName(name);
		})
		.catch(error => {
			console.error(error);
			alert("Unable to get your name");
		})
	},[]);
	
	return <p> Hello {name}! </p>;
};`}
        </code>
      </pre>
      <p className='text-justify'>
        En este caso tenemos la lógica encarga de consultar el nombre al
        servidor, y la interfaz encargada de mostrar ese nombre, en un mismo
        lugar.
        <strong> Esto está mal</strong>. Cuando querrámos entrar a modificar la
        lógica vamos a estar también tocando la interfaz, y viceversa. La
        interfaz no tiene por qué saber como funciona la lógica.
      </p>
      <p>Para solucionar podemos refactorizar:</p>
      <pre>
        <code className='language-javascript rounded'>
          {`
/** useName.ts */
import { useState } from "react";

const useName = (): string => {
	const [name, setName] = useState("");

	useEffect(() => {
		fetch("https://whatIsMyName.com/getName")
		.then(name => {
			setName(name);
		})
		.catch(error => {
			console.error(error);
			alert("Unable to get your name");
		})
	},[]);

	return name;
};

/** App.ts */
import React from "react";
import useName from "./useName.ts";

const App: React.FC = () => {
	const name = useName();
		
	return <p> Hello {name}! </p>;
};`}
        </code>
      </pre>
      Ahora abstraímos la lógica (para la interfaz) en un custom hook, que tiene
      un noombre muy declarativo (useName = usarNombre) que nos permite
      claramente hacer uso del nombre.{" "}
      <strong>A la interfaz no le importa cómo se obtiene ese nombre</strong>{" "}
      solo que se obtiene.
    </Container>
  );
};

export default new Content({
  Component: Componetizacion,
  title: "Componetización",
  route: "componetizacion",
  tags: [
    "buenas",
    "practicas",
    "componetizacion",
    "code",
    "code quality",
    "code-quality",
    "calidad",
    "código",
    "componentes",
    "módulos",
    "reglas",
    "desarrollo",
    "programación"
  ]
});
